import Collection from "../../valueObject/Collection";
import IFrameMessage from "../IFrameMessage";

export default class BecomeMemberMessage extends IFrameMessage {
    public static ACTION_NAME = "become-member-cta";
    constructor() {
        super(BecomeMemberMessage.ACTION_NAME);
    }

    public send() {
        super._send(new Collection({}));
    }

    public recieve(callback: Function) {
        callback();
    }
}
